<template>
  <v-card class="mx-auto overflow-hidden" width="600">
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      autocomplete="off"
    >
      <v-card-text>
        <div class="pb-4 subtitle-1">{{ $t("enterYourCurrentPassword") }}</div>
        <v-text-field
          :class="[
            !form.currentPassword || show ? 'show-password' : 'hide-password',
          ]"
          v-model="form.currentPassword"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('currentPassword')"
          solo-inverted
          @click:append="show = !show"
          required
          clearable
          name="oldPassword"
          tabindex="10"
          :error="errorCurrentPassword"
          autofocus
        ></v-text-field>
        <div class="pb-4 subtitle-1">{{ $t("enterANewPassword") }}</div>
        <v-text-field
          :class="[
            !form.newPassword || show1 ? 'show-password' : 'hide-password',
          ]"
          v-model="form.newPassword"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('newPassword')"
          :hint="$t('enterPasswordHinit')"
          :rules="[rules.passMin, rules.passCaracter, rules.max]"
          solo-inverted
          clearable
          @click:append="show1 = !show1"
          required
          name="newPassword"
          tabindex="11"
          :error="errorNewPassword"
          :counter="8"
          maxlength="8"
          autocapitalize="off"
        ></v-text-field>
        <v-text-field
          :class="[
            !form.confirmNewPassword || show2
              ? 'show-password'
              : 'hide-password',
          ]"
          v-model="form.confirmNewPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('confirmNewPassword')"
          :rules="passMatch"
          solo-inverted
          clearable
          @click:append="show2 = !show2"
          required
          name="confirmNewPassword"
          tabindex="12"
          :error="errorNewPassword"
          :counter="8"
          maxlength="8"
          autocapitalize="off"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="info"
          :loading="loading"
          v-on:click.prevent="changePassword"
          type="submit"
          :disabled="!valid"
          tabindex="14"
          >{{ $t("changePassword") }}</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import qs from "qs";

import { validate } from "@/util/validate.js";
export default {
  name: "administrator-change-password",
  data: () => ({
    valid: true,
    lazy: false,
    show: false,
    show1: false,
    show2: false,
    loading: false,
    form: {},
    hash: "",
    errorCurrentPassword: false,
    errorNewPassword: false,
    rules: {
      required: validate.required,
      passMin: validate.passRule,
      passCaracter: validate.passCaracter,
      max: validate.max,
    },
    confirmNewPassword: "",
    checkPasswordRules: {
      required: "Este campo é obrigatório.",
    },
  }),
  watch: {
    "form.currentPassword"() {
      this.errorCurrentPassword = false;
    },
    "form.confirmNewPassword"() {
      this.errorNewPassword = false;
    },
  },
  computed: {
    // Repet password
    passMatch() {
      const rules = [];
      // Required
      if (this.checkPasswordRules.required) {
        const rule = (v) => !!v || this.$t("inputRequired");
        rules.push(rule);
      }
      if (this.form.confirmNewPassword) {
        const rule = (v) =>
          (!!v && v) === this.form.newPassword || this.$t("repeatThePassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    changePassword() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const { currentPassword, newPassword, confirmNewPassword } = this.form;

        if (newPassword == confirmNewPassword) {
          const mapLevelToEndpointPrefix = {
            collaborator: "colab",
            administrator: "administrator",
            regionalManager: "regionalManager",
            localManager: "localManager",
          };

          const prefix =
            mapLevelToEndpointPrefix[localStorage.getItem("level")];

          this.$axios
            .post(
              `/${prefix}/profile/confirmPassword`,
              this.$formdata({
                password: currentPassword,
              })
            )
            .then((res) => {
              const body = {
                password: newPassword,
              };

              if (res.data.dados.hash) {
                body.hash = res.data.dados.hash;
              }

              const method = prefix === "colab" ? "post" : "put";

              this.$axios[method](
                `/${prefix}/profile/editPassword`,
                prefix === "colab" ? this.$formdata(body) : qs.stringify(body)
              )
                .then((resp) => {
                  this.$store.commit("setFeedbackSnack", {
                    msg: resp.data.messages,
                    color: "success",
                  });

                  this.$refs.form.reset();
                  this.$refs.form.resetValidation();
                })
                .catch(() => {
                  this.errorNewPassword = true;
                });
            })
            .catch(() => {
              this.errorCurrentPassword = true;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
